import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'



Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    newUser : {},
    userLogin : {},
    isLogin : localStorage.access_token ? true : false,
    products : [],
    currentPage : 1,
    totalPages : null,
    product : {},
    productId : null,
    email : '',
    password : '',
    categories : [],
    minPrice : '',
    maxPrice : '',
    categoryId : null,
    bookmarks : [],
    bookmarkId : '',
    use : '',
    tokenGoogle : ''
  },
  mutations: {
    SET_PRODUCT(state,payload){
      state.products = payload.products.result.rows
      state.currentPage = +payload.products.currentPage
      state.totalPages = payload.products.totalPages
    },
    CHANGE_PAGE(state,payload){
      state.currentPage = payload
    },
    SET_CATEGORIES(state,payload){
      
      state.categories = payload.getCategories
    },
    SEARCH_FILTER(state,payload){
    
      state.currentPage = 1
      state.categoryId = payload.categoryId
      state.minPrice = payload.minPrice,
      state.maxPrice = payload.maxPrice
    },
    REGISTER_USER(state,payload){
    
      state.newUser = payload
    },
    LOGIN_USER(state,payload){
  
      state.userLogin = payload
    },
    BOOKMARK_PRODUCT(state,payload){
      state.productId = payload
    },
    SET_BOOKMARK(state,payload){
      state.bookmarks = payload.bookmarks
    },
    DELETE_BOOKMARK(state,payload){
      state.bookmarkId = payload
    },
    DETAIL_PRODUCT(state,payload){
      state.productId = payload
    },
    SET_PRODUCTDETAIL(state,payload){
      state.product = payload
    },
    SET_LOGIN(state,payload){
      state.isLogin = true
      state.use = payload.email
    },
    LOGIN_GOOGLE(state){
      state.isLogin = true 
    },
    SET_LOGOUT(state){
      state.isLogin = false
    },
    CLEAR_SEARCH(state){
     
      state.minPrice = ''
      state.maxPrice = ''
      state.categoryId = ''
    }
  },
  actions: {
    fetchProducts(context){
      axios({
        method : 'GET',
        url : `https://brandedhackthingscustomer.herokuapp.com/customers/products?page=${context.state.currentPage}&minPrice=${context.state.minPrice}&maxPrice=${context.state.maxPrice}&categoryId=${context.state.categoryId}`
      })
      .then(response => {
       
        let products = response.data
        context.commit("SET_PRODUCT" ,{products})
      })
      .catch(err => {
        console.log(err);
      })
    },

    fetchCategories(context){
     
      axios({
        method : 'GET',
        url : `https://brandedhackthingscustomer.herokuapp.com/customers/categories`
      })
      .then(response => {
        let getCategories = response.data
        context.commit('SET_CATEGORIES', {getCategories})
      })
      .catch(err => {
        console.log(err);
      })
    },
    registerUser(context){
   
    const newUser = context.state.newUser
      return axios({
        method : 'POST',
        url : 'https://brandedhackthingscustomer.herokuapp.com/customers/register',
        data : newUser
      })
    },
    loginUser(context){

      const loginUser = context.state.userLogin
      return axios({
        method : 'POST',
        url : 'https://brandedhackthingscustomer.herokuapp.com/customers/login',
        data : loginUser
      })

    },
    loginGoogle(context,payload){
      return axios({
        method : 'POST',
        url : `https://brandedhackthingscustomer.herokuapp.com/customers/google-signin`,
        data : {
          id_token : payload
        }
      })
    },
    logoutUser(context){
      context.commit("SET_LOGOUT")
    },
    bookmarkProduct(context){
      const productId = context.state.productId
      return axios({
        method : "POST",
        url : 'https://brandedhackthingscustomer.herokuapp.com/customers/bookmarks',
        headers : {
          access_token : localStorage.access_token
        },
        data : {productId : productId}
      })
    },
    fetchBookmarks(context){
      axios({
        method : 'GET',
        url : 'https://brandedhackthingscustomer.herokuapp.com/customers/bookmarks',
        headers : {
          access_token : localStorage.access_token
        }
      })
      .then(response => {
        const bookmarks = response.data
        context.commit('SET_BOOKMARK', {bookmarks})

      })
      .catch(err => {
        console.log(err);
      })
    },
    deleteBookmark(context){
      const bookmarkId = context.state.bookmarkId
      axios({
        method : 'DELETE',
        url : `https://brandedhackthingscustomer.herokuapp.com/customers/bookmarks/${bookmarkId}`,
        headers : {
          access_token : localStorage.access_token
        }
      })
      .then(response => {
        console.log(response.data);
        
      })
      .catch(err => {
        console.log(err);
      })
    },
    detailProduct(context){
      const productId = +context.state.productId
      return new Promise((res,rej) => {
        axios({
          method : "GET",
          url : `https://brandedhackthingscustomer.herokuapp.com/customers/products/${productId}`
        })
        .then(response => {
          const product = response.data
        
          context.commit("SET_PRODUCTDETAIL", {product})
          res()
        })
        .catch(err => {
          rej(err)
        })
      })
    }
  },
  modules: {
  }
})
